export const IMESSAGE_CONNECTION_CLAIM_SEARCH_PARAM = "imessage_connection_claim";
const IMESSAGE_ONBOARDING_SETTINGS_SEARCH_PARAM = "settings";
const IMESSAGE_ONBOARDING_SETTINGS_VALUE = "mem-agent";

export const readIMessageConnectionClaimToken = ({
  searchParams,
}: {
  searchParams: URLSearchParams;
}): string | null => {
  const value = searchParams.get(IMESSAGE_CONNECTION_CLAIM_SEARCH_PARAM)?.trim();
  return value && value.length > 0 ? value : null;
};

export const withoutIMessageConnectionClaimSearchParam = ({
  searchParams,
}: {
  searchParams: URLSearchParams;
}): URLSearchParams => {
  const nextSearchParams = new URLSearchParams(searchParams);
  nextSearchParams.delete(IMESSAGE_CONNECTION_CLAIM_SEARCH_PARAM);
  if (
    nextSearchParams.get(IMESSAGE_ONBOARDING_SETTINGS_SEARCH_PARAM) ===
    IMESSAGE_ONBOARDING_SETTINGS_VALUE
  ) {
    nextSearchParams.delete(IMESSAGE_ONBOARDING_SETTINGS_SEARCH_PARAM);
  }
  return nextSearchParams;
};

export const removeIMessageConnectionClaimFromCurrentUrl = ({
  browserWindow = window,
}: {
  browserWindow?: Window;
} = {}): void => {
  const currentUrl = new URL(browserWindow.location.href);
  currentUrl.search = withoutIMessageConnectionClaimSearchParam({
    searchParams: currentUrl.searchParams,
  }).toString();

  if (currentUrl.hash.includes("?")) {
    const [hashPath, hashSearch = ""] = currentUrl.hash.split("?");
    const nextHashSearchParams = withoutIMessageConnectionClaimSearchParam({
      searchParams: new URLSearchParams(hashSearch),
    });
    const nextHashSearch = nextHashSearchParams.toString();
    currentUrl.hash = nextHashSearch ? `${hashPath}?${nextHashSearch}` : hashPath;
  }

  browserWindow.history.replaceState(
    browserWindow.history.state,
    "",
    `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`
  );
};
